export const partnerId = {
  innovationMissionPunjab: '6644f9847d7bab0015214424',
  deviare: '610a7ca8d3c51a1458d005ce',
};
